import { useQuery } from "@apollo/client";
import { CheckCircleIcon, SmallCloseIcon, WarningIcon } from "@chakra-ui/icons";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Center,
  Link,
  List,
  ListIcon,
  ListItem,
  Spinner,
  Tag,
  Text,
  useToast,
  Avatar,
  Flex,
} from "@chakra-ui/react";
import moment from "moment";
import { useState } from "react";
import { MdCheckCircle, MdOutlineSmsFailed } from "react-icons/md";
import { SALES_FOR_CUSTOMER } from "../../services/graphql/query/Sale";
import { ISale } from "../../services/graphql/Sale";
import { useCheckUser } from "../../services/hooks/useCheckUser";
import { MessageError } from "../../shared/MessageError";

export const Buys = () => {
  useCheckUser();
  const [loading, setLoading] = useState(true);
  const [buys, setBuys] = useState<ISale[]>([]);
  const toast = useToast();
  useQuery(SALES_FOR_CUSTOMER, {
    onCompleted: (data) => {
      const { sales } = data;
      setBuys(sales);
      setLoading(false);
    },
    onError: (error) => {
      toast({
        duration: 2500,
        position: "top",
        render: () =>
          MessageError(
            error.message ? error.message : "No pudimos recuperar sus compras."
          ),
      });
      setLoading(false);
    },
  });
  return (
    <>
      {loading ? (
        <Center>
          <Spinner />
        </Center>
      ) : (
        <>
          {buys.length ? (
            <>
              <Accordion allowToggle>
                {buys.map((buy) => (
                  <>
                    <AccordionItem>
                      <h2>
                        <AccordionButton>
                          <Box flex="1" textAlign="left">
                            <Box
                              display="flex"
                              justifyContent={{
                                base: "center",
                                md: "space-between",
                              }}
                              flexDirection={{ base: "column", md: "row" }}
                            >
                              <Flex
                                alignItems={{ base: "left", md: "center" }}
                                flexDirection={{ base: "column", md: "row" }}
                              >
                                {buy.sale_status === "Success" ? (
                                  <>
                                    <CheckCircleIcon
                                      color={"green.400"}
                                      mr={{ base: 0, md: 2 }}
                                      mx={"auto"}
                                    />
                                  </>
                                ) : buy.sale_status === "Pending" ? (
                                  <>
                                    <div
                                      style={{
                                        margin: "0 auto",
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <WarningIcon
                                        color={"yellow.400"}
                                        mr={{ base: 0, md: 1 }}
                                      />
                                      <Text
                                        color={"yellow.400"}
                                        mr={{ base: 0, md: 2 }}
                                      >
                                        Pendiente
                                      </Text>
                                    </div>
                                  </>
                                ) : buy.sale_status === "Failure" ? (
                                  <>
                                    <div
                                      style={{
                                        margin: "0 auto",
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Text
                                        color={"red.400"}
                                        mr={{ base: 0, md: 2 }}
                                      >
                                        Rechazada
                                      </Text>
                                    </div>
                                  </>
                                ) : null}
                                <Text mx={"auto"}>
                                  <span style={{ fontWeight: "bold" }}>
                                    Fecha:{" "}
                                  </span>
                                  {moment(buy.operation_date).format(
                                    "DD/MM/YYYY"
                                  )}{" "}
                                </Text>
                              </Flex>

                              {buy.shipment?.shipment_date ? (
                                <Text mx={{ base: "auto", md: 0 }}>
                                  <span style={{ fontWeight: "bold" }}>
                                    Fecha de envío:{" "}
                                  </span>
                                  {moment(buy.shipment?.shipment_date).format(
                                    "DD/MM/YYYY"
                                  )}{" "}
                                </Text>
                              ) : null}

                              <Text mx={{ base: "auto", md: 0 }}>
                                <span style={{ fontWeight: "bold" }}>
                                  Total:{" "}
                                </span>
                                ${buy.payment_total}{" "}
                              </Text>
                            </Box>
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                      </h2>
                      <AccordionPanel pb={4}>
                        <List spacing={3}>
                          {buy.sale_product.map((sale_product) => (
                            <>
                              <ListItem display={"flex"} alignItems="center">
                                {sale_product.product.url_image ? (
                                  <Avatar
                                    src={sale_product.product.url_image}
                                    size="lg"
                                    mr={3}
                                  />
                                ) : (
                                  <ListIcon
                                    as={MdCheckCircle}
                                    color="green.500"
                                  />
                                )}

                                <Box display={"flex"} flexDirection="column">
                                  <Text>
                                    <span style={{ fontWeight: "bold" }}>
                                      Producto:
                                    </span>{" "}
                                    {sale_product.product.name}{" "}
                                  </Text>
                                  <Text>
                                    <span style={{ fontWeight: "bold" }}>
                                      Cantidad:
                                    </span>{" "}
                                    {sale_product.quantity}{" "}
                                  </Text>
                                  <Text>
                                    <span style={{ fontWeight: "bold" }}>
                                      Precio unitario:
                                    </span>{" "}
                                    ${sale_product.unitary_total}{" "}
                                  </Text>
                                </Box>
                              </ListItem>
                            </>
                          ))}
                        </List>
                      </AccordionPanel>
                    </AccordionItem>
                  </>
                ))}
              </Accordion>
            </>
          ) : (
            <>
              <Center display={"flex"} flexDirection="column">
                <p>
                  <Tag>NO TIENES COMPRAS REGISTRADAS &#128532;</Tag>
                </p>
                <Link mt={5} className="link-without-underline" href="/">
                  <Button>Ir a ver productos</Button>
                </Link>
              </Center>
            </>
          )}
        </>
      )}
    </>
  );
};
